import { yupResolver } from '@hookform/resolvers/yup';
import { useContext, useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import Select from 'react-select';
import { toast } from 'react-toastify';
import {
  Col,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row
} from 'reactstrap';
import * as Yup from 'yup';
import CustomButton from '../../components/layout/CustomButton';
import InputField from '../../components/layout/InputField';
import { customSelectStyleNew } from '../../components/styled/customSelect';
import { ReportEnum } from '../../constants';
import { AppContext } from '../../context';
import { customStylesReportEditDropdown, reportCategory, URL_REGEX } from '../../utils/constant';

const validationSchema = Yup.object({
  name: Yup.string().required('Report Name is required!'),
  link: Yup.string().required('Report Link is required!').matches(URL_REGEX, "Invalid URL"),
});

interface IReportForm {
  name: string;
  link: string;
  category: any;
  id?: string;
}

const UpdateReportModal = ({
  toggle,
  isOpen,
  reportObj,
  updateReport,
  refetchData,
}) => {
  const { theme } = useContext(AppContext);
  const methods = useForm<IReportForm>({
    defaultValues: { name: '', link: '', category: reportCategory[0] },
    resolver: yupResolver(validationSchema) as any,
  });
  const { handleSubmit, formState: { errors }, register, reset, control, setValue } = methods;

  useEffect(() => {
    if (reportObj.id) {
      reset({
        name: reportObj.name,
        link: reportObj.link,
        category: { label: ReportEnum[reportObj?.category], value: reportObj.category },
        id: reportObj.id,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const updateReportHandler = async (data) => {
    data.id = reportObj?.id;
    const { category, ...result } = data;
    const finalInput = {
      category: category?.value,
      ...result,
    }
    let response = await updateReport({
      variables: { input: finalInput },
    });
    if (response?.data?.updateReport?.status === 200) {
      toggle();
      refetchData();
      toast.success('Report Updated Successfully!');
    } else {
      toggle();
      toast.error('Report could not be Updated!');
    }
  };
  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      className="revampDialog revampDialogWidth"
      centered
    >
      <ModalHeader className="py-3">
        <h4>Update Report</h4>
      </ModalHeader>
      <form onSubmit={handleSubmit(updateReportHandler)}>
        <ModalBody className="pt-3">
          <Row>
            <Col>
              <InputField
                inputtype="text"
                label="Report Name"
                inputid="name"
                isRequired={true}
                placeholder="Update Report Name..."
                {...register("name", {
                  required: {
                    value: true,
                    message: 'Report Name is required!',
                  },
                })}
                errMsg={errors?.name?.message as any}
              />
            </Col>
            <Col>
              <InputField
                inputtype="text"
                label="Report Link"
                inputid="link"
                isRequired={true}
                placeholder="Update Report Link..."
                {...register("link", {
                  required: {
                    value: true,
                    message: 'Report Link is required!',
                  },
                })}
                errMsg={errors?.link?.message as any}
              />
            </Col>
          </Row>

          <Row>
            <Col>
              <Controller
                name='category'
                control={control}
                rules={{
                  required: {
                    value: true,
                    message: 'Must Select Category!',
                  },
                }}
                render={({ field: { value, onChange } }) => (
                  <>
                    <Label>
                      Report Category
                      <span className="text-danger"> *</span>
                    </Label>
                    <Select
                      value={value}
                      options={reportCategory as any}
                      onChange={(object) => {
                        setValue('category', object as any)
                      }}
                      styles={{ ...customSelectStyleNew(theme) }}
                      isDisabled={true}
                    />
                    <small className="text-danger">
                      {errors?.category?.message as any}
                    </small>
                  </>
                )}
              />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter className='p-0'>
          <div className="d-flex justify-content-end align-items-center w-100">
            <button
              className="btn btn-primary buttonPrimary m-2"
              onClick={() => {
                reset();
                toggle();
              }}
              type="button"
            >
              Cancel
            </button>
            <CustomButton
              buttonText="Save"
              buttonColor="default"
              buttonType="submit"
              className="btn-primary py-2 m-3"
            />
          </div>
        </ModalFooter>
      </form>
    </Modal>
  );
};

export default UpdateReportModal;
